export const tourTypeSelector = state => state.tourType.tourType;
export const selectIsTourOpen = state => state.tourType.isTourOpen;

export const selectDidComponentRender = (state, name) =>
  state.tourType.didComponentRender[name] ?? false;
